module.exports = __webpack_public_path__ + "static/media/RehabSeattingLogo.cf0668a4.png";